import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSort = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M4.86 19.878V5.831L1.946 8.703a1.152 1.152 0 0 1-1.611 0 1.11 1.11 0 0 1 0-1.587l4.86-4.787A1.137 1.137 0 0 1 6 2a1.15 1.15 0 0 1 .806.329l4.86 4.787a1.11 1.11 0 0 1 0 1.587 1.152 1.152 0 0 1-1.61 0L7.138 5.83v14.047A1.128 1.128 0 0 1 6 21a1.13 1.13 0 0 1-1.14-1.122ZM19.14 3.122C19.14 2.502 18.63 2 18 2c-.63 0-1.14.502-1.14 1.122V17.17l-2.915-2.872a1.152 1.152 0 0 0-1.611 0 1.11 1.11 0 0 0 0 1.587l4.86 4.787.008.008a1.145 1.145 0 0 0 1.234.236c.131-.054.255-.132.362-.236l.008-.008 4.86-4.787a1.11 1.11 0 0 0 0-1.587 1.152 1.152 0 0 0-1.61 0l-2.917 2.872V3.122Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSort);
export default ForwardRef;
